"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PermissionsContext = react_1.default.createContext({
    permissions: {},
    roles: [],
});
exports.PermissionsContext = PermissionsContext;
//# sourceMappingURL=PermissionsContext.js.map